/**
 * @generated SignedSource<<3b0956598fb96827f616b663e44cf628>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ShopList_landingPage$data = {
  readonly list: {
    readonly listGroups: ReadonlyArray<{
      readonly listItems: ReadonlyArray<{
        readonly imageUrl: string | null;
        readonly title: string | null;
        readonly url: string | null;
      } | null> | null;
      readonly title: string | null;
    } | null> | null;
    readonly title: string | null;
  } | null;
  readonly " $fragmentType": "ShopList_landingPage";
};
export type ShopList_landingPage$key = {
  readonly " $data"?: ShopList_landingPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"ShopList_landingPage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ShopList_landingPage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "LandingPageList",
      "kind": "LinkedField",
      "name": "list",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "LandingPageListGroup",
          "kind": "LinkedField",
          "name": "listGroups",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "LandingPageListItem",
              "kind": "LinkedField",
              "name": "listItems",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "imageUrl",
                  "storageKey": null
                },
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "url",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "LandingPage",
  "abstractKey": null
};
})();

(node as any).hash = "db499c6d7e5021dffcb2168929c4f77b";

export default node;
